import {Component} from '@angular/core';
import { App } from 'ionic-angular';
import {NavController} from 'ionic-angular';
import {WelcomePage} from "../welcome/welcome";


@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(private app: App) {
  }

  goToWelcome(params) {
    if (!params) params = {};
    this.app.getRootNav().setRoot(WelcomePage);
    //this.navCtrl.popToRoot();
    //this.navCtrl.setRoot(WelcomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts